import Vue from 'vue'
import VueRouter from 'vue-router'
import Antd from 'ant-design-vue'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import store from './stores/global'
import 'ant-design-vue/dist/antd.css'
import VueDND from 'awe-dnd'
import JsonViewer from 'vue-json-viewer'
import router from './router'
import filter from './utils/filter'
import request from './utils/request'
import helper from './utils/helper'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import BUI from '@okee-uikit/vue';

for (const key in filter) {
  Vue.filter(key, filter[key])
}

Vue.config.productionTip = false

Vue.use(BUI);
Vue.use(VueRouter)
Vue.use(Antd)
Vue.use(VueDND)
Vue.use(JsonViewer)
Vue.use(VXETable)
Vue.prototype.$store = store
Vue.prototype.$helper = helper
sync(store, router)

VXETable.formats.mixin({
  empty: helper.emptyFormat,
  percent: filter.percent,
  roi: filter.roi,
})

new Vue({
  render: h => h(App),
  router,
  created() {
    request.vue = this
    request.setRequestInterceptor()
    request.setResponseInterceptor()
    this.$helper.vue = this
  }
}).$mount('#app')
